/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

/**
 * Controller for the admin dashboard page.
 */
angular.module('nsadmin').controller('dashboardController', ['$scope', '$injector',
    function dashboardController($scope, $injector) {

        var flaskApiService = $injector.get('flaskApiService');
        var $location = $injector.get('$location');

        /**
         * System settings.
         */
        $scope.settings = {
            powerOffDelay: 0
        };

        /**
         * Lab allocations summary.
         */
        $scope.labAllocations = [];

        /**
         * Loading state.
         */
        $scope.loading = true;

        /**
         * Error message if loading fails.
         */
        $scope.errorMessage = null;

        /**
         * Loads the dashboard data from the Flask API.
         */
        function loadDashboard() {
            $scope.loading = true;
            $scope.errorMessage = null;

            // For now, we'll just show a welcome message
            // In the full implementation, we'll load settings and lab allocations
            $scope.loading = false;

            console.log('Dashboard loaded');
        }

        /**
         * Updates system settings.
         */
        $scope.updateSettings = function updateSettings() {
            console.log('Update settings clicked (not yet implemented)');
            // TODO: Implement settings update via Flask API
            alert('Settings update will be implemented in the next phase');
        };

        /**
         * Navigates to the lab management page.
         */
        $scope.goToLabs = function goToLabs() {
            $location.path('/nsadmin/labs');
        };

        /**
         * Navigates to the pod management page.
         */
        $scope.goToPods = function goToPods() {
            $location.path('/nsadmin/pods');
        };

        /**
         * Navigates to the user management page.
         */
        $scope.goToUsers = function goToUsers() {
            $location.path('/nsadmin/users');
        };

        // Load dashboard data on controller initialization
        loadDashboard();
    }
]);
